import * as keyset from 'i18n/SkillPublishing';
import i18n from '@yandex-int/i18n';
import { Channel } from '../../model/skill';
import { DraftStatus, DraftStatusSmartHome } from '../../model/draft';
import { PublishingPageDangerousOperation } from '../../types';

const t = i18n(keyset);

type StatusDescriptions = Record<DraftStatus, string>;
type SmartHomeStatusDescription = Record<DraftStatusSmartHome, string>;

const skillStatusDescriptions: StatusDescriptions = {
    inDevelopment: t('status-in-dev'),
    reviewRequested: t('status-in-review'),
    reviewApproved: t('status-review-approved'),
    deployRequested: t('status-deploy'),
};

const skillStatusDescriptionsAired: StatusDescriptions = {
    inDevelopment: t('aired-in-dev'),
    reviewRequested: t('aired-in-review'),
    reviewApproved: t('aired-review-approved'),
    deployRequested: t('aired-deploy'),
};

const smartHomeStatusDescriptions: SmartHomeStatusDescription = {
    inDevelopment: t('status-in-dev'),
    reviewRequested: t('status-in-review'),
    devicesTesting: t('status-in-review'),
    devicesTestingCompleted: t('status-in-review'),
    meetingApproval: t('status-in-review'),
    waitingForTesting: t('status-in-review'),
    reviewApproved: t('status-review-approved'),
    deployRequested: t('status-deploy'),
};

const smartHomeStatusDescriptionsAired: SmartHomeStatusDescription = {
    inDevelopment: t('aired-in-dev'),
    reviewRequested: t('aired-in-review'),
    devicesTesting: t('aired-in-review'),
    devicesTestingCompleted: t('aired-in-review'),
    meetingApproval: t('aired-in-review'),
    waitingForTesting: t('aired-in-review'),
    reviewApproved: t('aired-review-approved'),
    deployRequested: t('aired-deploy'),
};

const thereminvoxStatusDescriptions: StatusDescriptions = {
    inDevelopment: t('status-in-dev'),
    reviewRequested: t('status-in-review'),
    reviewApproved: t('status-review-approved'),
    deployRequested: t('theremin-deploy'),
};

const thereminvoxStatusDescriptionsAired: StatusDescriptions = {
    inDevelopment: t('aired-in-dev'),
    reviewRequested: t('aired-in-review'),
    reviewApproved: t('aired-review-approved'),
    deployRequested: t('theremin-deploy'),
};

export const statusDescriptions = {
    [Channel.AliceSkill]: skillStatusDescriptions,
    [Channel.SmartHome]: smartHomeStatusDescriptions,
    [Channel.Thereminvox]: thereminvoxStatusDescriptions,
};

export const statusDescriptionsAired = {
    [Channel.AliceSkill]: skillStatusDescriptionsAired,
    [Channel.SmartHome]: smartHomeStatusDescriptionsAired,
    [Channel.Thereminvox]: thereminvoxStatusDescriptionsAired,
};

type DangerousOperationDescriptions = Record<PublishingPageDangerousOperation, string>;

const skillDangerousOperationsDescription: DangerousOperationDescriptions = {
    [PublishingPageDangerousOperation.Stop]: t('skill-stop-desc'),
    [PublishingPageDangerousOperation.Delete]: t('skill-delete-desc'),
};

const thereminvoxDangerousOperationsDescription: DangerousOperationDescriptions = {
    [PublishingPageDangerousOperation.Stop]: t('theremin-stop-desc'),
    [PublishingPageDangerousOperation.Delete]: t('theremin-delete-desc'),
};

export const dangerousOperations: Record<Channel, DangerousOperationDescriptions> = {
    [Channel.AliceSkill]: skillDangerousOperationsDescription,
    [Channel.AutoApp]: skillDangerousOperationsDescription,
    [Channel.SmartHome]: skillDangerousOperationsDescription,
    [Channel.SmartScreenApp]: skillDangerousOperationsDescription,
    [Channel.Thereminvox]: thereminvoxDangerousOperationsDescription,
    [Channel.TvApp]: skillDangerousOperationsDescription, // todo: fix
};
